import script from "./PageTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTabs.vue?vue&type=script&setup=true&lang=js"

import "./PageTabs.vue?vue&type=style&index=0&id=1f246f3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f246f3b"]])

export default __exports__